import React from "react";


export default function UpdateVehicleFine(){
return(

    <div className="updatevehiclefine-container my-4">
        <div className="col-md-12">      
              <div className="special-header">
            <div className="page-title">Update Vehicle Fine</div>
        </div>
             <form>
                    <div className="row update-vehicle-fine">
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="vehicleno" className="form-label"> Vehicle Number <span className="text-danger">*</span></label>
                            <select id="vehicleno" className="form-control updatevehiclefine-form-select" >
                                <option>Select</option>
                                <option>New Vehicle</option>
                                <option>MH02WE0002</option>
                                <option>MH02YE0902</option>
                            </select>
                        </div>
                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="driver" className="form-label"> Driver <span className="text-danger">*</span></label>
                             <select id="driver" className="form-control updatevehiclefine-form-select" >
                                <option>Select</option>
                                <option>New Driver</option>
                                <option>Ola Driver</option>
                                <option>Uber Driver</option>
                            </select>
                               </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="reason" className="form-label"> Reason <span className="text-danger">*</span>  </label>
                            <input type="text" id="reason" className="form-control updatevehiclefine-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="status" className="form-label">Status<span className="text-danger">*</span> </label>
                            <input type="text" id="status" className="form-control updatevehiclefine-form-control" />
                        </div>

                        <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="amount" className="form-label"> Amount<span className="text-danger">*</span></label>
                            <input type="text" id="amount" className="form-control updatevehiclefine-form-control" />
                        </div>

                         <div className="col-lg-6 col-md-12 mb-3">
                            <label htmlFor="date" className="form-label"> Date<span className="text-danger">*</span></label>
                            <input type="date" id="date" className="form-control updatevehiclefine-form-control" />
                        </div>

                        <div className="col-lg-12 col-md-12 mt-3 d-flex justify-content-end">
                            <button to="/" type="submit" className="btn custom-btn">Update</button>
                        </div>
                    </div>
                </form>
    </div>
    </div>

);
}

